module.exports = __webpack_public_path__ + "media/Adekunle-Gold-x-Simi-Promise.0b9cd1bc.mp3";